export const TYPE_DEFAULT = 'DEFAULT' as const;
export const TYPE_EXTERNAL = 'EXTERNAL' as const;
export const TYPE_FAVORITES = 'FAVORITES' as const;

export const TYPE_ENUMS = [TYPE_DEFAULT, TYPE_EXTERNAL, TYPE_FAVORITES] as const;
